export const DELETE_ITEM = 'DELETE_ITEM';

export const deleteItem = ({ id, context }) => ({
  type: DELETE_ITEM,
  id,
  context,
});
